:host(c-toast) {
  /**
   * @prop --c-toast-background-color: Toast background color
   * @prop --c-toast-text-color: Toast text color
   */
  --_c-toast-background-color: var(--c-toast-background-color, var(--c-white));
  --_c-toast-text-color: var(--c-toast-text-color, var(--c-text-system));

  // private
  --_c-toast-animation-state: running;

  align-items: center;
  background-color: var(--_c-toast-background-color);
  border-radius: 6px;
  border: 2px solid var(--_c-toast-color);
  border-left-width: 12px;
  box-shadow:
    rgba(0, 0, 0, 0.07) 0 1px 1px, rgba(0, 0, 0, 0.07) 0 2px 2px,
    rgba(0, 0, 0, 0.07) 0 4px 4px, rgba(0, 0, 0, 0.07) 0 8px 8px,
    rgba(0, 0, 0, 0.07) 0 16px 16px;
  box-sizing: border-box;
  color: var(--_c-toast-text-color);
  display: grid;
  min-height: 52px;
  opacity: 0;
  padding: 8px 12px;
  pointer-events: all;
  text-align: left;
  transform: translateY(20px);
  transition: opacity 0.5s ease, transform 0.5s ease;
  width: 100%;
  will-change: opacity, transform;
  z-index: 10001;
  position: relative;
}

:host(.show) {
  opacity: 1;
  transform: translateY(0);
}

:host(.info) {
  --_c-toast-color: var(--c-info-600);
}

:host(.error) {
  --_c-toast-color: var(--c-error-600);
}

:host(.warning) {
  --_c-toast-color: var(--c-warning-600);
}

:host(.success) {
  --_c-toast-color: var(--c-success-600);
}

.c-toast__content p {
  margin: 0;
  font-weight: 600;
}

.c-toast__item {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-auto-columns: auto;
  grid-auto-flow: column;
  grid-template-columns: 24px 1fr;
  font-weight: 300;
}

.c-toast__item > svg {
  fill: var(--_c-toast-color);
}

.c-toast__item svg {
  height: 24px;
  width: 24px;
}

.c-toast__progress {
  background-color: var(--c-tertiary-200);
  border-radius: 8px;
  height: 6px;
  margin-top: 8px;
  overflow: hidden;
  transform: translateZ(0);
}

:host(:hover) {
  --_c-toast-animation-state: paused;
}

.c-toast__progress__bar {
  animation-duration: var(--_c-toast-duration);
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: timer;
  animation-play-state: var(--_c-toast-animation-state);
  animation-timing-function: linear;
  background-color: var(--_c-toast-color);
  border-radius: 8px;
  height: 6px;
  width: 100%;
}

.c-toast__progress__bar.indeterminate {
  animation: indeterminate 2s infinite linear;
  left: -100%;
  width: 50%;
  position: relative;
  transform-origin: 0% 50%;
}

.visuallyhidden {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

@keyframes timer {
  100% {
    transform: translateX(-100%);
  }
}

@keyframes indeterminate {
  0% {
    transform: translateX(100%) scaleX(1);
  }

  30% {
    transform: translateX(170%) scaleX(1.75);
  }

  70% {
    transform: translateX(500%) scaleX(0.1);
  }

  100% {
    transform: translateX(500%) scaleX(0.1);
  }
}
